import { Role, type UserRoleFilter } from "@/types/user";
import type { UserProfile } from "@/types/user-profile";

export type UsersTranslate = (key: string, defaultValue?: string) => string;

/** Group column header, shared by the Users table and the CSV export. */
export const getUsersGroupHeader = (t: UsersTranslate): string =>
  t("users.table.hotelGroup", "Hotel Group");

/** Same role label as the Users table. */
export const getUserRoleLabel = (
  t: UsersTranslate,
  role?: UserRoleFilter,
): string => {
  if (!role) return "—";

  if (role === Role.FRONT_DESK) return t("users.table.frontDesk");
  if (role === Role.HOTEL_ADMIN) return t("users.table.hotelAdmin");
  if (role === Role.TENANT_ADMIN) return t("users.table.tenantAdmin");
  if (role === Role.STAFF) return t("users.table.staff");
  if (role === "GUESTERIA_ADMIN") {
    return t("users.table.guesteriaAdmin", "Guesteria Admin");
  }
  if (role === "SUPER_ADMIN") {
    return t("users.table.superAdmin", "Super Admin");
  }

  return role;
};

/** Custom role names when present, otherwise the base role label. */
export const getUserDisplayRoleLabel = (
  t: UsersTranslate,
  row: UserProfile,
): string => {
  if (row.customRoles && row.customRoles.length > 0) {
    return row.customRoles
      .map((customRole) => customRole.customRoleName)
      .join(", ");
  }
  return getUserRoleLabel(t, row.role);
};
